import 'css-chunksrc/client/common/projectSection/resizeable/styles.scss';export default {
  "grabbed": "_grabbed_1fy3n_1",
  "handle": "_handle_1fy3n_10"
};